import { render, staticRenderFns } from "./mm-header.vue?vue&type=template&id=620ccd4e&"
import script from "./mm-header.vue?vue&type=script&lang=js&"
export * from "./mm-header.vue?vue&type=script&lang=js&"
import style0 from "./mm-header.vue?vue&type=style&index=0&id=620ccd4e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports